import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const FALLBACK = {
  company_name: 'Wealth Management - Global Real Assets',
  address_line1: '142 rue de Rivoli',
  address_line2: '75001 Paris',
  phone: '07 56 87 74 22',
  // Pas d'email PII en fallback (LOT Public Design A bis) — le footer
  // affichera un CTA « Nous contacter » qui pointe vers /contact.
  contact_email: '',
  compliance_email: '',
};

let _cache = null;
let _promise = null;

/**
 * Hook to read centralized company contact info.
 * Uses /api/company-info with in-memory cache and static fallback.
 * Safe for legal pages: always returns valid data, never undefined fields.
 */
export function useCompanyInfo() {
  const [info, setInfo] = useState(_cache || FALLBACK);

  useEffect(() => {
    if (_cache) { setInfo(_cache); return; }
    if (!_promise) {
      _promise = axios.get(`${API}/api/company-info`)
        .then(r => {
          if (r.data?.company_name) {
            _cache = { ...FALLBACK, ...r.data };
          } else {
            _cache = FALLBACK;
          }
          return _cache;
        })
        .catch(() => { _cache = FALLBACK; return _cache; });
    }
    _promise.then(data => setInfo(data));
  }, []);

  return info;
}

/** Full address as a single string */
export function formatAddress(ci) {
  return `${ci.address_line1 || FALLBACK.address_line1}, ${ci.address_line2 || FALLBACK.address_line2}`;
}
